module.exports = __webpack_public_path__ + "static/media/HT.08381c4a.svg";